import { useCallback, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import InvoiceDraft from './invoiceDraft';
import InvoiceSigned from './invoiceSigned';
import { Page, Tabs } from '@shopify/polaris';
import { Helmet } from 'react-helmet-async';
import { useGetInvoices_analytics } from 'queries/invoices.query';
import InvoiceEditModal from './invoiceEditModal';
import InvoiceSignedError from './invoiceError';
import InvoiceSignedSuccess from './invoiceSuccess';
import { FolderDownIcon } from '@shopify/polaris-icons';
import { useAuth } from 'context/AuthContext';
export default function InvoiceManagerMainTab() {
  const { data: analyticsData } = useGetInvoices_analytics();
  let { slug = 'all' } = useParams();

  const history = useNavigate();

  const tabs = useMemo(
    () => [
      {
        id: 'all',
        content: 'Xuất thành công',
        badge: analyticsData ? analyticsData.signed_success.toString() : '0',
      },
      {
        id: 'draft',
        content: 'Chờ ký',
        badge: analyticsData ? analyticsData.not_signed.toString() : '0',
      },
      {
        id: 'exported',
        content: 'Đã ký',
        badge: analyticsData ? analyticsData.signed.toString() : '0',
      },

      {
        id: 'exportedError',
        content: 'Xuất lỗi',
        badge: analyticsData ? analyticsData.signed_error.toString() : '0',
      },
    ],
    [analyticsData]
  );

  const selected = useMemo(() => {
    const index = tabs.findIndex((item) => item.id === slug);
    return index >= 0 ? index : 0;
  }, [slug, tabs]);

  const handleTabChange = useCallback(
    (selectedTabIndex: number) => {
      let id = tabs[selectedTabIndex].id;
      switch (id) {
        case 'all':
          history('/invoices');
          break;
        case 'draft':
          history('/invoices/draft');
          break;
        case 'exported':
          history('/invoices/exported');
          break;
        case 'exportedError':
          history('/invoices/exportedError');
          break;
      }
    },
    [history, tabs]
  );

  const [currentEditInvoice, setCurrentEditInvoice] = useState(null);
  const [showInvoiceEditModal, setShowInvoiceEditModal] = useState(false);

  return (
    <>
      <Helmet>
        <title>Quản lý mọi hành trình và xuất hóa đơn</title>
      </Helmet>

      <Page fullWidth title="Quản lý hóa đơn">
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}></Tabs>
        <br />
        {slug === 'draft' ? <InvoiceDraft /> : null}
        {slug === 'exported' ? (
          <InvoiceSigned
            currentInvoiceCallback={(invoiceID) => {
              setCurrentEditInvoice(invoiceID);
              setShowInvoiceEditModal(true);
            }}
          />
        ) : null}
        {slug === 'exportedError' ? (
          <InvoiceSignedError
            currentInvoiceCallback={(invoiceID) => {
              setCurrentEditInvoice(invoiceID);
              setShowInvoiceEditModal(true);
            }}
          />
        ) : null}
        {slug === 'all' ? <InvoiceSignedSuccess /> : null}
      </Page>

      <InvoiceEditModal
        invoice_id={currentEditInvoice}
        show={showInvoiceEditModal}
        onClose={() => {
          setShowInvoiceEditModal(false);
          setCurrentEditInvoice(null);
        }}
      />
    </>
  );
}

